import { min, max } from 'd3-array';
import { bandAxis, linearAxis } from '../../../factory/axes';
import data from './data/data.json';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 30,
    right: isMobile ? 10 : 30,
    bottom: 20,
    left: 30,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  // const padding = 0.15;
  const padding = 0;

  const maxValue = max(data, d => d.amt);
  const minValue = min(data, d => d.amt);

  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, width - 15],
    domain: data.map(d => d.label),
    padding,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [height, 0],
    domain: [0, 7000000],
    nice: false,
  };

  const { axis: xAxis, scale: x } = bandAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  return {
    data,
    initialWidth,
    initialHeight,
    width,
    height,
    x,
    y,
    xAxis,
    yAxis,
    margins,
  };
}
